import { render, staticRenderFns } from "./BannerThumb.vue?vue&type=template&id=600310a3&scoped=true&"
import script from "./BannerThumb.vue?vue&type=script&lang=js&"
export * from "./BannerThumb.vue?vue&type=script&lang=js&"
import style0 from "./BannerThumb.vue?vue&type=style&index=0&id=600310a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600310a3",
  null
  
)

export default component.exports